import {
  appVersion,
  numbers,
  specialChars,
  description,
  topRightUELogoEnabled,
  appLogoTopUrl,
  appLogoBottomUrl,
  showFooterEULogotypes,
  applicationSubmittedTo
} from './base.config';

export const environment = {
  appVersion,
  specialChars,
  numbers,
  description,
  topRightUELogoEnabled,
  appLogoTopUrl,
  appLogoBottomUrl,
  showFooterEULogotypes,
  applicationSubmittedTo,
  exposedMapTargetOrigin: 'https://public-map-powiatnowomiejskitest.smart-gem.pl/',
  production: false,
  apiBasePath: 'https://um-lodz.test.aspello.pl/system/api/v1',
  ssl: false
};
